export default "__VITE_ASSET__Cm1X7Bko__"